import { render, staticRenderFns } from "./SoliPurchaseOption.vue?vue&type=template&id=a8242c26"
import script from "./SoliPurchaseOption.vue?vue&type=script&lang=js"
export * from "./SoliPurchaseOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports